<template>
  <div class="warehousingPage">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item, index) in bannerList" :key="index"
        ><van-image width="100%" height="100%" :src="item"
      /></van-swipe-item>
    </van-swipe>

    <div class="main_content">
      <div class="goods_desciption">
        <p class="txt1 fontSize-blueColor-md">商品ID：{{ detail.id }}</p>
        <p class="txt2 fontSize-blueColor-md">商品名称：</p>
        <p class="txt3">{{ detail.commodityname }}</p>
        <p class="txt3">{{ detail.commodityname_e }}</p>
        <p class="txt3">{{ detail.commodityname_y }}</p>
        <p class="txt3">{{ detail.commodityname_m }}</p>
        <p class="txt3">{{ detail.commodityname_t }}</p>
        <p class="txt1 fontSize-blueColor-md">SKU采购编码：{{ detail.sku }}</p>
        <p class="fontSize-blueColor-md">ISBN编码： {{ detail.ISBN }}</p>
      </div>
    </div>

    <div class="return_group">
      <div class="primary-button" @click="handleGo">设置采购参数</div>
    </div>

    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>
  </div>
</template>

<script>
import storage from "../../utils/storage";
export default {
  name: "pManageDetail",
  data() {
    return {
      detail: "",
      bannerList: [],
    };
  },
  created() {
    this.getInit();
  },
  methods: {
    getInit() {
      this.detail = storage.get("GOODDETAIL");
      let bannerList = [];
      bannerList.push(this.detail.banner);
      bannerList.push(this.detail.banner2);
      bannerList.push(this.detail.banner3);
      bannerList.push(this.detail.banner4);
      bannerList.push(this.detail.banner5);
      let filter = bannerList.filter((item) => item !== null && typeof item !== "undefined" && item !== "");
      this.bannerList = filter;
    },
    handleReturn() {
      history.back();
    },

    handleGo() {
      this.$router.push('/purchaseIndex/pManageSet')
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingPage {
  padding-bottom: 150px;
  .my-swipe {
    width: 750px;
    height: 750px;
    background: #eeeeee;
  }
  .main_content {
    padding: 79px 100px;
    .txt3 {
      font-size: 28px !important;
    }
  }
  .btn_group {
    margin-top: 89px;
    .btn1 {
      margin-bottom: 57px;
    }
  }
}
</style>